import { ProductIdentifierDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

export class ProductComparePreviewItem {
  public productIdentifier: ProductIdentifierDto | undefined;
  public description: string | undefined;
  public thumbnail: string | undefined;
}
